import React, { useContext, useEffect, useRef } from "react";
import "./CheckoutEditConfirmPopup.css";
import { ReactComponent as CloseIcon } from "../../assets/icons/close.svg";
import Button from "../../UI/Button/Button";
import { LocaleContext } from "../../AppProvider";

const CheckoutEditConfirmPopup = ({
  close,
  onConfirm
}: {
  close: () => void;
  onConfirm: () => void;
}) => {
  const { t } = useContext(LocaleContext);
  const mountedRef = useRef(true);

  useEffect(() => {
    const originalOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";

    return () => {
      document.body.style.overflow = originalOverflow;
      mountedRef.current = false;
    };
  }, []);

  return (
    <div onClick={close} className="checkout_edit_confirm_popup_wrapper center">
      <div
        onClick={(e) => {
          e.stopPropagation();
        }}
        className="checkout_edit_confirm_popup_container"
      >
        <div onClick={close} className="float_close center">
          <CloseIcon className="img_div_contain close_icon" />
        </div>
        <h3 className="checkout_edit_confirm_popup_title">
          {t("Edit Booking" as any) || "Edit Booking"}
        </h3>
        <p className="checkout_edit_confirm_popup_text">
          {t(
            "Are you sure you want to edit the booking? Your currently reserved slot will be canceled and you may not find the same available time" as any
          ) ||
            "Are you sure you want to edit the booking? Your currently reserved slot will be canceled and you may not find the same available time"}
        </p>
        <div className="checkout_edit_confirm_popup_buttons">
          <Button plane onClick={close} size="sm">
            {t("Cancel" as any) || "Cancel"}
          </Button>
          <Button onClick={onConfirm} size="sm">
            {t("Confirm" as any) || "Confirm"}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default CheckoutEditConfirmPopup;
